export default {"src":"/_next/static/media/fantasy-tips-icon.4c94a664.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};